import { useEffect } from 'react';
import { useLazyGoals } from '@atlassian/jira-portfolio-3-atlas-goals';
import { setLazyGoalsState } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issue-goals/actions';
import type { LazyGoalsState } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issue-goals/types';
import { connect } from '@atlassian/jira-react-redux';

type Props = {
	setLazyGoalsState: (payload: LazyGoalsState) => void;
};

const GoalStateSync = ({ setLazyGoalsState: dispatchSetLazyGoalsState }: Props) => {
	const [state] = useLazyGoals();

	useEffect(() => {
		dispatchSetLazyGoalsState(state);
	}, [dispatchSetLazyGoalsState, state]);

	return null;
};

export default connect(null, { setLazyGoalsState })(GoalStateSync);
